import { render, staticRenderFns } from "./PaypalCardPay.vue?vue&type=template&id=a7ffbace&"
import script from "./PaypalCardPay.vue?vue&type=script&lang=ts&"
export * from "./PaypalCardPay.vue?vue&type=script&lang=ts&"
import style0 from "./PaypalCardPay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports